/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AlertaModalService } from '../util/alerta-modal.service';
import { Constants } from '../../constants/constants';
import { UserDataDto } from '../../dto/auth/user-data.dto';
import { AutenticacionService } from '../../modules/auth/services/autenticacion.service';
import { FuncionalidadService } from '../funcionalidad.service';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = (route, state) => {
  const isSecure = environment.esHttps;
  const autenticacionService = inject(AutenticacionService);
  const alertaService = inject(AlertaModalService);
  const funcionalidadService = inject(FuncionalidadService);
  const router = inject(Router);
  const usuario = sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE);
  const tipoUsuario = sessionStorage.getItem(Constants.USER_TYPE);
  let primerInicio = false;

  // Access the URL from the state
  const { url } = state;
  const categorias = ['PATH', 'Menu', 'Home', 'Tramites'];
  let authToken;

  // Check if the URL contains 'observatorio-de-justicia'
  if(!isSecure){
    const isObservatorioURL = url.includes('/observatorio-de-justicia');
    authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN);
    // Handle the access token based on the URL and authToken presence
    if (isObservatorioURL) {
      if (authToken) {
        // Save the access token in localStorage
        localStorage.setItem(Constants.ACCESS_TOKEN, authToken);
      } else {
        authToken = localStorage.getItem(Constants.ACCESS_TOKEN);
        if (authToken) {
          sessionStorage.setItem(Constants.ACCESS_TOKEN, authToken);
        }
      }
      return true;
    } else {
      // Remove the access token if it exists in localStorage
      localStorage.removeItem(Constants.ACCESS_TOKEN);
    }
  }

  if (usuario) {
    const usuarioDto: UserDataDto = JSON.parse(usuario);
    primerInicio = usuarioDto.primerInicioSesion!;

    if (tipoUsuario) {
      const tipoUsuarioDto = JSON.parse(tipoUsuario);
      let rol = tipoUsuarioDto.Nombre;
      let rolId = tipoUsuarioDto.Id;
      let entidad = tipoUsuarioDto.Id_Entidad;

      return funcionalidadService
        .obtenerUrlFuncionalidadesPorTipoUsuarioYCategoria(rolId, categorias)
        .pipe(
          switchMap((urlsPermitidas: string[]) => {
            //console.log('🔍 URLs obtenidas de BD:', urlsPermitidas);

            // Convertir las URLs permitidas en expresiones regulares
            const regexUrls = urlsPermitidas.map(
              url => new RegExp('^' + url.replace(/:[^/]+/g, '([^/]+)') + '$')
            );

            // Verificar si la URL actual coincide con algún patrón permitido
            const accesoPermitido = regexUrls.some(regex => regex.test(url));

            if (accesoPermitido) {
              //console.log('✅ Acceso Permitido a', url);
              return of(true);
            } else {
              //console.log('🚫 Acceso Denegado a', url);
              autenticacionService.logout();
              router.navigate(['/login']);
              return of(false);
            }
          }),
          catchError(error => {
            console.error('❌ Error al cargar las funcionalidades:', error);
            autenticacionService.logout();
            router.navigate(['/login']);
            return of(false);
          })
        );

    }

  }

  if (!isSecure && !authToken) {
    if (router.url !== '/login') {
      autenticacionService.logout();
      if (router.url !== '/' && router.url !== '') {
        alertaService.error(
          'La sesión ha expirado. Por favor inicie sesión nuevamente'
        );
      }
      router.navigate(['/login']);
    }
    return true;
  }

  /*if (primerInicio === true) {
    router.navigate(['/cambiar-contrasenia']);
    return false;
  }*/

  /*if (true) {
    console.log("guard token",authToken)
    console.log("guard usuario",usuario)
    router.navigate(['/cambiar-contrasenia']);
    return false;
  }*/

  return true;
};
